'use strict';

/**
 * Browser stub for @okta/jwt-verifier.
 * tempus-okta-client@4 uses the Node-only verifier during logout; therapies runs in the browser.
 * Okta validates id_token_hint server-side — a lightweight structural check is enough here.
 */
class OktaJwtVerifier {
  constructor(_config) {}

  verifyIdToken(token) {
    if (!token || typeof token !== 'string' || token.split('.').length !== 3) {
      return Promise.reject(new Error('Invalid ID token'));
    }

    return Promise.resolve({ claims: {} });
  }
}

module.exports = OktaJwtVerifier;
module.exports.default = OktaJwtVerifier;
